import { func } from 'prop-types'

import RightActive from '../../../../../img/arrow-right-active.svg'
import LeftActive from '../../../../../img/arrow-left-active.svg'

function resetButtons() {
  document.getElementById('bzfy-c-main-icon-right').style.opacity = 1
  document.getElementById('bzfy-c-right-icon').style.backgroundColor = '#999'
  document.getElementById('bzfy-c-main-icon-center').style.opacity = 1
  document.getElementById('bzfy-c-main-icon-left').style.opacity = 1
  document.getElementById('bzfy-c-left-icon').style.backgroundColor = '#999'
}

function toggleOpacities(side, opposite) {
  document.getElementById(`bzfy-c-${side}-icon`).style.backgroundColor = '#666'
  document.getElementById('bzfy-c-main-icon-center').style.opacity = 0.66
  document.getElementById(`bzfy-c-${opposite}-icon`).style.backgroundColor = '#999'

  setTimeout(() => resetButtons(), 450)
}

function MobileCarouselControl({ leftFunc, rightFunc }) {
  function handleRightClick() {
    toggleOpacities('right', 'left')
    rightFunc()
  }

  function handleLeftClick() {
    toggleOpacities('left', 'right')
    leftFunc()
  }
  return (
    <div className="bzfy-c-mobile-carousel-control">
      <div
        className="bzfy-c-mobile-circle bzfy-c-left"
        id="bzfy-c-left-icon"
        onClick={handleLeftClick}
        onKeyDown={handleLeftClick}
        role="button"
        tabIndex={0}
      >
        <img
          alt="Navigate left"
          className="bzfy-c-main-icon"
          id="bzfy-c-main-icon-left"
          src={LeftActive}
        />
      </div>
      <div className="bzfy-c-mobile-circle bzfy-c-active" id="bzfy-c-main-icon-center">
        <div className="bzfy-c-main-icon bzfy-c-center-icon" />
      </div>
      <div
        className="bzfy-c-mobile-circle bzfy-c-right"
        id="bzfy-c-right-icon"
        onClick={handleRightClick}
        onKeyDown={handleRightClick}
        role="button"
        tabIndex={0}
      >
        <img
          alt="Navigate right"
          className="bzfy-c-main-icon"
          id="bzfy-c-main-icon-right"
          src={RightActive}
        />
      </div>
    </div>
  )
}

MobileCarouselControl.propTypes = {
  leftFunc: func.isRequired,
  rightFunc: func.isRequired,
}

export default MobileCarouselControl
